import React from 'react';

const SeleccionCategoria = ({ setCategoria }) => {
  const categorias = ['Super Mario', 'The Legend of Zelda', 'Pokémon', 'Super Smash Bros.'];

  return (
    <div className="seleccion-categoria">
      <h1>Quiz de Nintendo</h1>
      <h2>Selecciona una categoría</h2>
      <div className="categorias">
        {categorias.map((cat) => (
          <button key={cat} onClick={() => setCategoria(cat)}>
            {cat}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SeleccionCategoria;